import React, { FC, type ReactNode, useEffect, useState } from 'react'
import MenuItem from 'components/base-ui/MenuItem'
import { useTranslation } from 'react-i18next'
import { PaymentMethod } from 'types/payment'
import { PaymentTypeEnum } from 'graphQL/dinein/generate/operations'
import CreditCardDetails from 'components/PaymentMethod/CreditCardDetails'
interface PaymentMethodItemProps {
  paymentMethod: PaymentMethod
  isActive: boolean
  onClick: () => void
}

interface Item {
  iconName: string
  title: ReactNode
}

const PaymentMethodItem: FC<PaymentMethodItemProps> = ({ paymentMethod, isActive, onClick }) => {
  const { t } = useTranslation()
  const [paymentLabel, setPaymentLabel] = useState<Item>({
    iconName: '',
    title: '',
  })
  const { iconName, title } = paymentLabel
  useEffect(() => {
    switch (paymentMethod.type) {
      case PaymentTypeEnum.BankTransfer:
        setPaymentLabel({
          iconName: 'qrcode-outline',
          title: t('bankTransfer'),
        })
        break
      case PaymentTypeEnum.OmiseCreditCard:
        try {
          const {
            creditCard: { cardBrand, cardLastDigits, cardholderName },
          } = paymentMethod
          setPaymentLabel({
            iconName: 'credit-card',
            title: (
              <CreditCardDetails
                cardBrand={cardBrand}
                cardholderName={cardholderName}
                cardLastDigits={cardLastDigits}
              />
            ),
          })
        } catch (error) {
          setPaymentLabel({
            iconName: 'credit-card',
            title: 'creditCard',
          })
        }
        break
      case PaymentTypeEnum.Cash:
        setPaymentLabel({
          iconName: 'cash',
          title: t('cashOnDelivery'),
        })
        break
      case PaymentTypeEnum.ScbPromptPay:
        setPaymentLabel({
          iconName: 'qrcode-outline',
          title: t('qrcodePayment'),
        })
        break
      case PaymentTypeEnum.KBankThaiQr:
        setPaymentLabel({
          iconName: 'qrcode-outline',
          title: t('paymentMethodPage.paymentMethod.qrKBank'),
        })
        break
      case PaymentTypeEnum.OmisePromptPay:
        setPaymentLabel({
          iconName: 'qrcode-outline',
          title: t('qrcodePayment'),
        })
        break
      case PaymentTypeEnum.OmiseTrueMoneyWallet:
        setPaymentLabel({
          iconName: `${process.env.PUBLIC_URL}/assets/payment/icon-true-money-wallet.png`,
          title: t('trueMoneyWallet'),
        })
        break
      case PaymentTypeEnum.KPaymentKPlusNumber:
        setPaymentLabel({
          iconName: `${process.env.PUBLIC_URL}/assets/payment/icon-kplus.png`,
          title: t('kplusPayment'),
        })
        break
      case PaymentTypeEnum.KPaymentPromptPayNumber:
        setPaymentLabel({
          iconName: 'mobile',
          title: t('kbankPromptpayPayment'),
        })
        break
    }
  }, [paymentMethod])

  const isUseImage =
    paymentMethod.type === PaymentTypeEnum.OmiseTrueMoneyWallet ||
    paymentMethod.type === PaymentTypeEnum.KPaymentKPlusNumber

  const isShowIconPrefix = paymentMethod.type !== PaymentTypeEnum.OmiseCreditCard

  return isUseImage ? (
    <MenuItem
      testId="paymentTypeBtn"
      imagePath={iconName}
      isShowIconPrefix={isShowIconPrefix}
      title={title}
      iconAction="arrow-right-bold"
      isActive={isActive}
      onClick={onClick}
    />
  ) : (
    <MenuItem
      testId="paymentTypeBtn"
      icon={iconName}
      isShowIconPrefix={isShowIconPrefix}
      title={title}
      iconAction="arrow-right-bold"
      isActive={isActive}
      onClick={onClick}
      outline={!paymentMethod.type}
    />
  )
}

export default PaymentMethodItem
